module.exports = __webpack_public_path__ + "static/media/rightmain.b6517c78.webp";